import { ChatComposeBoxAddAttachmentMenuItem } from '@glade-ai/chat-plugin/ui';
import { type ComponentPropsWithoutRef, type ReactElement, forwardRef } from 'react';

import PriceSelector from '@/components/PriceSelector';
import Spacer from '@/components/Spacer';
import { mixpanelTrack } from '@/providers/Mixpanel';
import type getRecentlyUsedPrices from '@/tsClient/creators/getRecentlyUsedPrices';

type Props = {
  onAttach: (data: { priceId: string; title: string }) => void;
};
type Price = Awaited<ReturnType<typeof getRecentlyUsedPrices>>[0];

const ADD_PAYMENT_LINK_LABEL = 'Payment Link';
const ADD_PAYMENT_LINK_ICON = 'ph--currency-dollar-simple--regular';

export const AddPaymentLinkMenuItem = forwardRef<
  HTMLDivElement,
  Omit<ComponentPropsWithoutRef<typeof ChatComposeBoxAddAttachmentMenuItem>, 'icon' | 'label'>
>((props, forwardedRef) => (
  <ChatComposeBoxAddAttachmentMenuItem
    {...props}
    ref={forwardedRef}
    icon={ADD_PAYMENT_LINK_ICON}
    label={ADD_PAYMENT_LINK_LABEL}
  />
));
AddPaymentLinkMenuItem.displayName = 'AddPaymentLinkMenuItem';

export const AddPaymentLinkPopoverContent = ({ onAttach }: Props): ReactElement => {
  const handleInsert = (price: Price): void => {
    mixpanelTrack('InputComposer - payment link added to input');
    onAttach({ priceId: price.id, title: price.priceTitle || price.product?.title || 'Payment Link' });
  };

  return (
    <>
      <div style={{ padding: 16 }}>
        <p className='body-sm'>
          <b>Payment Links</b>
        </p>
        <Spacer size={12} />
        <PriceSelector onPriceSelect={handleInsert} />
      </div>
    </>
  );
};
